// @flow

export type LineType = {
  id: number,
  text: string,
  syllables?: number,
  stresses?: number,
};

export type MetaType = {
  id: number,
  title: string,
  authors: string,
  key: string,
  filename: string,
};

export const SectionTypes = [
  // '',
  'Verse',
  'Chorus',
  'Bridge',
  'Tag',
  'Instrumental',
  'Intro',
  'Outro',
  'Pre-chorus',
  'Interlude',
];

export type SectionType = {
  id: number,
  label?: string,
  lines?: Array<number>,
  type?: | ''
    | 'Verse'
    | 'Chorus'
    | 'Bridge'
    | 'Tag'
    | 'Instrumental'
    | 'Intro'
    | 'Outro'
    | 'Pre-chorus'
    | 'Interlude',
};



// WEBPACK FOOTER //
// ./src/types/entities.js